<template>
  <div class="subject">
    <div class="title">
      <div class="flex-center">
        <img src="../assets/images/subject/kcxx.png" style="height: 24px"/>
        <span>{{$config.staticConfig.isNeed ? $config.staticConfig.titleList.mainttitle : '课程信息'}}</span>
      </div>
      <div>
        <router-link to="/subject">更多{{$config.staticConfig.isNeed ? '' : '课程'}}</router-link>
      </div>
    </div>
    <div class="content">
      <div class="item" :selected="i===1 && true" v-for="(s,i) in currentSubject" :key="`subject_${i}`"
           @click="activeScene(s.sceneId)">
        <div class="left">
          <div><span v-text="getPosition(i)"></span></div>
          <div><span v-text="s.name"></span></div>
          <div><span v-text="$config.staticConfig.isNeed ? $config.staticConfig.titleList.speaker + '：' :`授课老师：`" class="xs-hide"></span><span v-text="s.teacher"></span></div>
        </div>
        <div class="right">
          <span class="min-hide">{{$config.staticConfig.isNeed ? $config.staticConfig.titleList.time : '授课时间'}}：</span>
          <span v-text="s.start"></span>
          <span>~</span>
          <span v-text="s.end"></span>
          <img v-if="s.isScene" src="../assets/images/subject/kcld.png" style="width: 25px"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import comm from '../assets/lib/comm'
import scene from '../model/scene'
import { Message } from 'element-ui'

export default {
  name: 'Subject',
  computed: {
    ...mapState(['subject', 'scenes']),
    currentSubject () {
      const todaySubject = this.subject && this.subject[(new Date().getDay() || 7)]
      if (!todaySubject) {
        return this.subject && [
          { name: '--', start: '--', end: '--', teacher: '--', isScene: false },
          { name: '--', start: '--', end: '--', teacher: '--', isScene: false },
          { name: '--', start: '--', end: '--', teacher: '--', isScene: false }
        ]
      }
      // 更新场景关联关系
      todaySubject.forEach(s => {
        const ass = this.scenes.filter(sc => sc.alias && sc.alias.indexOf(s.name) > -1)
        if (ass.length) {
          s.isScene = true
          s.sceneId = ass[0].id
        } else {
          s.isScene = false
        }
      })
      this.$store.commit('UPDATE_SUBJECT', { week: (new Date().getDay() || 7), data: todaySubject })
      // 同时寻找当前课程，上节课程和下节课程
      let index = [-1, -1, -1]
      todaySubject.forEach((s, i) => {
        const start = new Date(comm.dateFormat(new Date(), 'yyyy/MM/dd HH:mm:ss').split(' ')[0] + ' ' + s.start)
        const end = new Date(comm.dateFormat(new Date(), 'yyyy/MM/dd HH:mm:ss').split(' ')[0] + ' ' + s.end)
        if (new Date() >= start && new Date() <= end) {
          index[1] = i
        } else if (new Date() < start && index[2] === -1) {
          index[2] = i
        } else if (new Date() > end) {
          index[0] = i
        }
      })
      return this.subject && [
        index[0] === -1 ? {
          name: '--',
          start: '--',
          end: '--',
          teacher: '--',
          isScene: false
        } : todaySubject[index[0]],
        index[1] === -1 ? {
          name: '--',
          start: '--',
          end: '--',
          teacher: '--',
          isScene: false
        } : todaySubject[index[1]],
        index[2] === -1 ? {
          name: '--',
          start: '--',
          end: '--',
          teacher: '--',
          isScene: false
        } : todaySubject[index[2]]
      ]
    }
  },
  mounted () {
    this.interval = comm.timerInClock(() => {
      this.$forceUpdate()
    }, 1, 30)
  },
  methods: {
    getPosition (i) {
      let obj = this.$config.staticConfig
      let isNeed = obj.isNeed
      if (i === 0) {
        return isNeed ? obj.titleList.subtitle[i] : '上节课程'
      } else if (i === 1) {
        return isNeed ? obj.titleList.subtitle[i] : '当前课程'
      } else {
        return isNeed ? obj.titleList.subtitle[2] : '下节课程'
      }
    },
    async activeScene (id) {
      if (id) {
        // 切换场景
        try {
          await scene.active(id)
          this.$store.commit('ACTIVE_SCENE', id)
        } catch (e) {
          Message.error(e.message)
        }
      }
    }
  },
  beforeDestroy () {
    // 清除页面的定时器，定时器主要用于切换当前课程
    this.interval && clearInterval(this.interval)
  }
}
</script>

<style scoped lang="less">
@import "../assets/less/base";

.subject {
  /*width:733px;*/
  /*height:240px;*/
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 10px 1px rgba(219, 219, 219, 0.1);
  border-radius: 4px;
  padding: 5px 20px 20px 20px;
  > .title {
    padding: 20px 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 18px;
    font-weight: 600;
    color: rgba(38, 38, 38, 1);
    img {
      margin-right: 8px;
    }
    .flex-center {
      display: flex;
      align-items: center
    }
  }
  > .content {
    .item[selected] {
      color: #32D374;
    }
    .item {
      cursor: pointer;
      height: 50px;
      align-items: center;
      border-top: 1px solid rgba(244, 248, 250, 1);;
      display: flex;
      justify-content: space-between;
      > .left {
        display: flex;
        > div:first-child {
          font-size: 15px;
          margin-left: 25px;
          font-weight: bold;
        }
        > div:nth-child(2) {
          font-size: 16px;
          margin-left: 32px;
          font-weight: bold;
        }
        > div:nth-child(3) {
          font-size: 12px;
          margin-left: 17px;
          display: flex;
          align-items: center;
        }
      }
      > .right {
        font-size: 13px;
        font-weight: 400;
        display: flex;
        align-items: center;
        .text-right;
        span {
          margin-left: 3px;
        }
        img {
          margin-left: 11px;
        }
      }
    }
  }
}
</style>
